import { takeLatest, call, put } from "redux-saga/effects";
import { PARTNER_ADD_REQUEST, partnerAddError } from "../../actions/partners";
import addPartner from "../../../../../backend/oncall/administration/partners/add";
import { push } from "react-router-redux/actions";

const requestAdd = function*(action) {
  try {
    const result = yield call(
      addPartner,
      action.payload.formData.name,
      parseInt(action.payload.formData.internalId, 10),
      action.payload.formData.enabled,
      "",
    );
    yield put(push(`/partner/edit/${result.partnerId}`));
  } catch (error) {
    yield put(partnerAddError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(PARTNER_ADD_REQUEST, requestAdd);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/partners/request-add.js